// Minimum gap between forced JWT refresh attempts triggered by Knock's
// `tokenExpiring` callback. Prevents a thundering-herd refetch loop if Knock
// repeatedly reports an expiring token.
export const KNOCK_TOKEN_REFRESH_THROTTLE_MS = 60 * 1000;

// Sentinel button action that closes the guide without navigating. Knock
// dashboard authors set a button's action to this value to get "Got it" style
// dismiss behavior — archives the step the same way the X icon does.
export const KNOCK_DISMISS_ACTION = "dismiss";
